module.exports = __webpack_public_path__ + "static/hot-selling-disinfection-product-ed94669755e9e406a40a8f05a18346a1.png";